import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Loader from "components/Atoms/SharedComponents/Loader/Loader";
import ColorRow from "components/Atoms/SharedComponents/Wrappers/Colors/ColorRow";
import { toast } from "react-toastify";
import ProductOptionValuesTemplate from "../../templates/products-option-values";
import {
  createProductOptionValueRequest,
  deleteProductOptionValueRequest,
  getProductOptionValueDetailsRequest,
  getProductsOptionValuesRequest,
  updateProductValueRequest,
} from "../../services/modules/lookups/productOptionValues";
import { getScrollProductsOptionTypesRequest } from "../../services/modules/lookups/productOptionTypes";

function ProductsOptionValuesPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");
  const isStore = localStorage.getItem("user_type") === "Store";

  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const permissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions.option_values,
  );
  const isSuperAdmin = currentUser?.privilege === "super_admin";

  const list = useSelector(
    (state) => state.productsOptionValues?.productsOptionValues,
  );
  const count = useSelector((state) => state.productsOptionValues?.count);
  const details = useSelector(
    (state) => state?.productsOptionValues?.productOptionValue,
  );
  const load = useSelector((state) => state.productsOptionValues?.load);

  const options = useSelector(
    (state) => state.productsOptionTypes?.productsOptionTypes,
  );
  const filterProductsOptionTypes = useSelector(
    (state) => state.productsOptionTypes?.filterProductsOptionTypes,
  );
  const productsOptionTypesCount = useSelector(
    (state) => state.productsOptionTypes?.listCount,
  );
  const productsOptionTypesLoading = useSelector(
    (state) => state.productsOptionTypes?.load,
  );

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [page, setPage] = useState(1);

  const [filterObj, setFilterObj] = useState(null);

  const getProductOptionType = (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        in_filter: true,
        ...filterObj,
      },
    };
    dispatch(getScrollProductsOptionTypesRequest(requestData));
  };
  // useEffect(() => {
  //   const requestData = {
  //     params: {
  //       page_size: 10,
  //       page_number: 1,
  //       keyword: "",
  //       sort_by: "id",
  //       ...filterObj,
  //     },
  //   };
  //   type == "form" && dispatch(getProductsOptionTypesRequest(requestData));
  // }, [type]);

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const getDetails = async () => {
    console.log(id);
    dispatch(getProductOptionValueDetailsRequest({ option_value_id: id }));
  };

  const getList = async (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        option_type_id: null,
        ...filterObj,
      },
    };
    dispatch(getProductsOptionValuesRequest(requestData));
  };
  const fetchProductOptionType = (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        ...filterObj,
      },
    };
    dispatch(getScrollProductsOptionTypesRequest(requestData));
  };
  // mappedData use for create custom cell to concat multi values or navigate button
  const mappedData = list?.map((data, index) => {
    return {
      ...data,
      // button: <Button variant="outline">test</Button>,
      presentationValue: data?.presentation,
      presentation: <ColorRow data={data} />,
      image: data?.image ? (
        <img
          src={data?.image}
          alt={
            data?.localized_data?.en?.name ||
            t("products_option_values.product")
          }
          width="125px"
          height="77px"
        />
      ) : (
        t("products_option_values.no_image")
      ),
    };
  });

  const rowData = (data) => {
    setSelectedRow(data);
  };
  const breadcrumbs = [
    {
      active: true,
      path: "/",
      title: t("common.home"),
    },
    {
      active: !type ? false : true,
      path: "/products-option-values",
      title: t("products_option_values.title"),
    },
    type && {
      active: false,
      title:
        type === "details"
          ? t("products_option_values.details")
          : id
            ? t("products_option_values.edit")
            : t("products_option_values.add"),
    },
  ];

  const handelSubmit = (data, formik) => {
    const type = options.find((option) => option?.id === data?.optionType);
    const action = () => {
      searchParams.delete("id");
      searchParams.delete("type");
      navigate("/products-option-values");
      !id && formik?.resetForm();

      toast.success(
        id
          ? t("products_option_values.updated")
          : t("products_option_values.created"),
      );
    };
    const requestData = {
      body: {
        option_value: {
          ...formik?.values,
          presentation:
            type?.name === "Color" || type?.name === "color" || !type?.name
              ? data?.presentation
              : data?.en.name,
        },
      },
      action,
    };
    if (id) {
      dispatch(updateProductValueRequest({ ...requestData, id }));
    } else {
      //create call
      dispatch(createProductOptionValueRequest(requestData));
    }
  };

  const filterList = [
    {
      type: "filter",
      placeholder: t("products_option_types.option_type"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, option_type_id: value?.value, page_number: 1 };
        });
      },
      onMenuOpen: () => {
        filterProductsOptionTypes?.length === 0 && getProductOptionType({});
      },
      options: filterProductsOptionTypes && filterProductsOptionTypes,
      getList: getProductOptionType,
      applySearchFromRequest: true,
      count: productsOptionTypesCount,
    },
  ];
  const handleDelete = (id) => {
    // const id = details?.id ? details?.id : selectedRow?.rowData?.id;
    //action to be called after successfull deletion
    const action = () => {
      //if list.length == 1 & page !== 1 -> setPage(page-1) & fetch
      if (list.length === 1 && page !== 1) {
        setPage(page - 1);
        setFilterObj((prev) => ({
          ...prev,
          page_number: page - 1,
        }));
      } else {
        getList(filterObj);
      }

      toast.success(t("products_option_values.deleted"));
    };
    const requestData = {
      id,
      action, //dispatched on success
    };
    dispatch(deleteProductOptionValueRequest(requestData));
    setOpenDeleteModal(false);
  };

  const handleOptionValueApprove = (id, data) => {
    const action = () => {
      toast.success(t("products_option_values.approved"));
      getList(filterObj);
    };
    const requestData = {
      body: {
        option_value: {
          option_type_id: data?.option_type_id,
          approval_status: "approved",
          en: {
            name: data?.localized_data?.en?.name,
          },
          ar: {
            name: data?.localized_data?.ar?.name,
          },
          presentation: data?.presentationValue,
          image: data?.image,
        },
      },
      id,
      action,
    };
    dispatch(updateProductValueRequest(requestData));
  };

  const handleOptionValueReject = (id, data) => {
    const action = () => {
      toast.success(t("products_option_values.rejected"));
      getList(filterObj);
    };
    const requestData = {
      body: {
        option_value: {
          option_type_id: data?.option_type_id,
          approval_status: "rejected",
          en: {
            name: data?.localized_data?.en?.name,
          },
          ar: {
            name: data?.localized_data?.ar?.name,
          },
          presentation: data?.presentationValue,
          image: data?.image,
        },
      },
      id,
      action,
    };
    dispatch(updateProductValueRequest(requestData));
  };

  //list of actions to be displayed when clicked in the 3 dots
  const actionsList = ({ index, data }) => {
    const status = data?.approval_status;
    return [
      {
        condition: () => {
          return isSuperAdmin || permissions?.can_update;
        },
        click: () => {
          navigate(`?type=form&id=${data?.id}`);
        },
        text: t("common.edit"),
      },
      {
        condition: () => {
          return isSuperAdmin || permissions?.can_delete;
        },
        click: () => {
          setOpenDeleteModal(true);
        },
        text: t("common.delete"),
      },
      {
        condition: () => {
          return status === "pending_approval" && !isStore;
        },
        click: () => {
          handleOptionValueApprove(data?.id, data);
        },
        text: t("products_option_values.approve"),
      },
      {
        condition: () => {
          return status === "pending_approval" && !isStore;
        },
        click: () => {
          handleOptionValueReject(data?.id, data);
        },
        text: t("products_option_values.reject"),
      },
    ];
  };

  //if you need more buttons in the header beside the add button
  const headerChildren = <></>;

  //if more modals needed, pass them to the modalComponents as below

  const modalComponents = [];

  //listing all tags
  useEffect(() => {
    if (filterObj) getList(filterObj);
  }, [filterObj]);

  //details of a single tag
  useEffect(() => {
    if (id) getDetails();
  }, [id]);

  const optionTypesOptions = {
    optionTypes: {
      options: [details?.option_type, ...filterProductsOptionTypes],
      onOpen: filterProductsOptionTypes?.length <= 1 && fetchProductOptionType,
      isLoading: productsOptionTypesLoading?.loading,
      getList: fetchProductOptionType,
      count: productsOptionTypesCount,
    },
  };

  return (
    <>
      <Loader open={load?.loading && load?.type === "list"} />
      <ProductOptionValuesTemplate
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        data={mappedData}
        count={count}
        paginationPage={page}
        handlePageChange={handlePageChange}
        rowData={rowData}
        details={details}
        breadcrumbs={breadcrumbs}
        filterList={filterList}
        handelSubmit={handelSubmit}
        actionsList={actionsList}
        headerChildren={headerChildren}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        handleDeleteRequest={handleDelete}
        modalComponents={modalComponents}
        selectedRow={selectedRow}
        can_create={isSuperAdmin || permissions?.can_create}
        optionTypesOptions={optionTypesOptions}
        filterProductsOptionTypes={filterProductsOptionTypes}
      />
    </>
  );
}

export default ProductsOptionValuesPage;
